module.exports = __webpack_public_path__ + "static/img/Tallyn-Da-Silva.a1e326a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Tallyn-Da-Silva.jpg
// module id = jCtm
// module chunks = 0